import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DevicesComponent } from './device-components/devices/devices.component';
import { LdsEnergyDetailComponent } from './device-components/lds-energy-detail/lds-energy-detail.component';
import { MainComponent } from './main/main.component';
import { LdsAccessGuard } from './lds-access.guard';
import { EnergyMainComponent } from './energy-components/energy-main/energy-main.component';
import { EnergyOverviewComponent } from './energy-components/energy-overview/energy-overview.component';
import { HomeComponent } from './home-components/home/home.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { AboutComponent } from './about/about.component';
import { HeatingDetailComponent } from './device-components/heating-detail/heating-detail.component';
import { SwitchDetailComponent } from './device-components/switch-detail/switch-detail.component';
// import { EnergyMonitorComponent } from './device-components/energy-monitor/energy-monitor.component';
import { MotionSensorComponent } from './device-components/motion-sensor/motion-sensor.component';
import { BatteryListComponent } from './battery/battery-list/battery-list.component';
import { WireFreeComponent } from './device-components/wire-free/wire-free.component';
import { EnergyMonitorListComponent } from './lw600/energy-monitor-list/energy-monitor-list.component';
import { EnergyMonitorComponent } from './lw600/energy-monitor/energy-monitor.component';
const DataStudioRoutes: Routes = [
    {
        path: 'data-studio',
        pathMatch: 'prefix',
        canActivate: [LdsAccessGuard],
        component: MainComponent,
        children: [
            {
                path: 'devices',
                component: DevicesComponent,
            },
            {
                path: 'detail/wire-free/:id',
                component: WireFreeComponent,
                pathMatch: 'full'
            },
            {
                path: 'detail/energy/:id',
                component: LdsEnergyDetailComponent,
                pathMatch: 'full',
            },
            {
                path: 'detail/temperature/:id',
                component: HeatingDetailComponent,
                pathMatch: 'full',
            },
            {
                path: 'detail/switch/:id',
                component: SwitchDetailComponent,
                pathMatch: 'full',
            },
            {
                path: 'detail/motion/:id',
                component: MotionSensorComponent,
                pathMatch: 'full',
            },
            {
                path: 'home',
                component: HomeComponent
            },
            {
                path: 'feedback',
                component: FeedbackComponent
            },
            {
              path: 'about',
              component: AboutComponent
            },
            {
                path: 'battery',
                component: BatteryListComponent
            },
            {
                path: 'energy',
                component: EnergyMainComponent,
                children: [{
                    path: 'overview',
                    component: EnergyOverviewComponent,
                }]
            },
            {
                path: 'energy-monitors',
                component: EnergyMonitorListComponent
            },
            {
                path: 'energy-monitor/:id',
                component: EnergyMonitorComponent
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(DataStudioRoutes)
    ],
    exports: [
        RouterModule
    ],
    declarations: []
})
export class LdsAppRoutingModule { }
